import * as U from './util';
import {useState} from 'react';
import {VIDEO_CONFIG_OPTIONS} from './controller';
import {ConstraintsModal} from './constraints-config-modal';
import {DropMenu, DropMenuItem} from './drop-menu';
import {BUTTON_STYLE_MAIN_FLEX} from './styles';

type VideoConfigSelectorProps = {
  handleSetConfig: (config: string | undefined) => void;
  handleSetManualConstraints: (constraints: MediaTrackConstraints | undefined) => void;
  initialManualConstraints?: MediaTrackConstraints;
};

export function VideoConfigSelector({
  handleSetConfig,
  handleSetManualConstraints,
  initialManualConstraints,
}: VideoConfigSelectorProps) {
  const [isConstraintsModalOpen, setIsConstraintsModalOpen] = useState<boolean>(false);

  function handleSelectVideoConfig(config: string | undefined) {
    U.appLog(`handleSelectVideoConfig ${config}`);
    if (config === 'Default') {
      handleSetConfig(undefined);
    } else if (config === 'Custom') {
      setIsConstraintsModalOpen(true);
    } else {
      handleSetConfig(config);
    }
  }

  const defaultVideoConfigLabel = 'Default';

  const videoConfigMenuItems: DropMenuItem[] = [
    'Custom',
    defaultVideoConfigLabel,
    ...Object.keys(VIDEO_CONFIG_OPTIONS),
  ].map(config => {
    return {
      value: config,
      callback: () => handleSelectVideoConfig(config),
    };
  });

  return (
    <>
      <DropMenu
        label="Video Config"
        items={videoConfigMenuItems}
        style={BUTTON_STYLE_MAIN_FLEX}
        initialValue={defaultVideoConfigLabel}
      />
      <ConstraintsModal
        isOpen={isConstraintsModalOpen}
        initialConfig={initialManualConstraints}
        setConstraintsCallback={handleSetManualConstraints}
        setOpen={setIsConstraintsModalOpen}
      />
    </>
  );
}
